import { useTranslation } from '@egw/i18n'
import { type FC } from 'react'

export interface TradeFieldProps {
  /**
   * Label
   */
  label: string

  /**
   * subtitle
   */

  subtitle?: string
  /**
   * Value
   */
  value: JSX.Element | number | string | null | undefined
}

export const TradeField: FC<TradeFieldProps> = ({ label, value, subtitle }) => {
  const { t } = useTranslation('features-transactions')
  return (
    <div className="flex w-full flex-row justify-between border-light last-of-type:border-b-0 border-b py-4">
      {/* label */}
      <div className="flex flex-col">
        <p className="typo-primary-base-regular text-text-body">{label}</p>
        {subtitle ? <p className="typo-primary-sm-regular text-text-meta">{subtitle}</p> : null}
      </div>
      {/* value */}
      <div className="flex flex-row text-header typo-primary-base-semibold">
        {value ?? t('trade_details.empty_state')}
      </div>
    </div>
  )
}
